/* eslint-disable no-undef */
import { capitalize } from 'lodash';
import { popup } from '.';
import { exportStore } from '../..';
import { ERROR, HEADERS, HTTP_CODES, LOCAL_STORAGE, ROUTES } from '../../constants';
import { setSessionPopup } from '../../redux';
import { getLocalStorageItem } from './localStorage';

const DEFAULT_HEADERS = { 'Content-Type': HEADERS.APPLICATION_JSON };

const useHeaders = (customHeaders) => {
    const apiHeaders = { ...DEFAULT_HEADERS, ...customHeaders };
    const authToken = getLocalStorageItem(LOCAL_STORAGE.AUTH_TOKEN);
    if (authToken) apiHeaders['Authorization'] = `${HEADERS.AUTHORIZATION} ${authToken}`;
    return apiHeaders;
};

export const fetchData = async ({ body, method, url, headers = {} }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const customHeader = useHeaders(headers);
    const apiUrl = process.env.REACT_APP_BASE_URL + url;

    const response = await fetch(apiUrl, {
        body: JSON.stringify(body),
        method,
        headers: customHeader,
    });

    // 204/205 responses have no body; avoid JSON parse errors
    if (response.status === 204 || response.status === 205) {
        return { statusCode: response.status };
    }

    let json;
    try {
        json = await response.json();
    } catch (e) {
        // Non‑JSON or empty body (e.g. some 4xx/5xx) — normalize to a generic
        // error envelope so callers don't see "Unexpected end of JSON input".
        json = { status: 'error', message: e.message || 'Unexpected response format' };
    }

    if (response.status === HTTP_CODES.INVALID_TOKEN) {
        const { router } = require('../../AppRouter');
        if (json.message === ERROR.JWT_EXPIRED) {
            exportStore.dispatch(setSessionPopup(true));
            setTimeout(() => {
                localStorage.clear();
                window.location.href = '/';
                window.location.reload();
            }, process.env.REACT_APP_REFRESH_TOKEN_TIME_DIFFERENCE);
            return;
        } else {
            localStorage.clear();
            popup('error', capitalize(json.message));
            router.navigate(ROUTES.HOME);
            return;
        }
    } else if (response.status === 419) {
        localStorage.clear();
        window.location.href = '/';
        throw new Error('Session expired');
    } else if (response.status === HTTP_CODES.INTERNAL_SERVER_ERROR) {
        const { router } = require('../../AppRouter');
        router.navigate(ROUTES.SERVER_ERROR);
        throw new Error('Internal Server Error');
    } else if (json.status === 'error') {
        throw new Error(json.message);
    } else {
        return { ...json, statusCode: response.status };
    }
};
